module.exports = __webpack_public_path__ + "img/Weapon_109.0d991224.png";